var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 27.5C21.9036 27.5 27.5 21.9036 27.5 15C27.5 8.09644 21.9036 2.5 15 2.5C8.09644 2.5 2.5 8.09644 2.5 15C2.5 21.9036 8.09644 27.5 15 27.5Z",
    fill: "#314DDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3281 15.0002L19.2031 12.1252C19.5656 11.7627 19.5656 11.1627 19.2031 10.8002C18.8406 10.4377 18.2406 10.4377 17.8781 10.8002L15.0031 13.6752L12.1281 10.8002C11.7656 10.4377 11.1656 10.4377 10.8031 10.8002C10.4406 11.1627 10.4406 11.7627 10.8031 12.1252L13.6781 15.0002L10.8031 17.8752C10.4406 18.2377 10.4406 18.8377 10.8031 19.2002C10.9906 19.3877 11.2281 19.4752 11.4656 19.4752C11.7031 19.4752 11.9406 19.3877 12.1281 19.2002L15.0031 16.3252L17.8781 19.2002C18.0656 19.3877 18.3031 19.4752 18.5406 19.4752C18.7781 19.4752 19.0156 19.3877 19.2031 19.2002C19.5656 18.8377 19.5656 18.2377 19.2031 17.8752L16.3281 15.0002Z",
    fill: "#314DDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.b931c6200125f7ed24526b29afe12274.svg";
export { ForwardRef as ReactComponent };